import React, { useState, useEffect }  from 'react';
import { useUser }          from '../contexts/UserContext.js'
import { findPermission }   from '../utils/UserPermissionUtils.js'
import { useNavigate }      from 'react-router-dom'

import '../styles/main.css';

import FarolForm            from '../components/Form/FarolForm';
import GoogleCronogramChart from '../components/GoogleCharts/GoogleCronogramChart';

function FarolDashboardPage() {

    const { userData }  = useUser()
    const navigate      = useNavigate()

    useEffect(() => {
        
        if (!userData?.permissions) return;
    
        const hasPermission = findPermission(userData, "Acesso Dashboard");
        if (!hasPermission) {
          navigate("/home");
        }
    
      }, [userData, navigate]);
   
    function createCustomHTMLContent(HtmlContent){
    
        return `<div style="padding:5px 5px 5px 5px; border-radius: 4px; color: #333B41; transition: 0.3s ease"> ${HtmlContent} </div>`;
    }
    
    const handleOpenModal = () => {
        setIsModalOpen(true);
    };
    
    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    
    const [isModalOpen, setIsModalOpen] = useState(false);

    const dataRightMargin = [

        //Creating Lines
        ['BRACELL', '', '#f0f0f0', "",      new Date(2024, 11, 1),   new Date(2024, 11, 1)],
        ['BRACELL', '', '#f0f0f0', "",      new Date(2024, 11, 30),  new Date(2024, 11, 30)],
        ['SUZANO',      '', '#f0f0f0', "",  new Date(2024, 11, 1),   new Date(2024, 11, 1)],
        ['CLI',         '', '#f0f0f0', "",  new Date(2024, 11, 1),   new Date(2024, 11, 1)],
        ['TAC',         '', '#f0f0f0', "",  new Date(2024, 11, 1),   new Date(2024, 11, 1)],
        ['T12A',        '', '#f0f0f0', "",  new Date(2024, 11, 1),   new Date(2024, 11, 1)],
        ['ECOPORTO',    '', '#f0f0f0', "",  new Date(2024, 11, 1),   new Date(2024, 11, 1)],
        ['HIDROVIAS',   '', '#f0f0f0', "",  new Date(2024, 11, 1),   new Date(2024, 11, 1)],




        ['T39', 'Estoque elevado',  '#FDC24E', createCustomHTMLContent("Farelo 48%: Em restrição, I84 e G60 com descarga garantida"), new Date(2024, 11,  3), new Date(2024, 11,  4)],
        ['T39', 'Estoque elevado',  '#FDC24E', createCustomHTMLContent("Farelo 48%: Em restrição, I84 e G60 com descarga garantida"), new Date(2024, 11, 26), new Date(2024, 11, 29)],

        ['TES', 'Plugado',          '#C70039', createCustomHTMLContent("Milho Cargill: Cliente reservando o espaço disponível para recebimento de farelo 46%"), new Date(2024, 11, 16), new Date(2024, 11, 22)],
        ['TES', 'Plugado',          '#C70039', createCustomHTMLContent("Milho Cargill: Cliente reservando o espaço disponível para recebimento de farelo 46%"), new Date(2024, 11, 3),  new Date(2024, 11, 10)],

        ['ADM', 'Estoque elevado',  '#FDC24E', createCustomHTMLContent("Milho: Em restrição, estoque elevado"), new Date(2024, 11,  1), new Date(2024, 11,  3)],
        ['ADM', 'Plugado',          '#C70039', createCustomHTMLContent("Farelo 46%: Após trem estacionado em ZCP (Y98) terminal não terá programação de recebimento ferroviário do produto"), new Date(2024, 11, 10), new Date(2024, 11, 12)],

        ['TGRÃO', 'Estoque elevado',  '#FDC24E', createCustomHTMLContent("Milho: Em restrição, estoque elevado"), new Date(2024, 11,  4), new Date(2024, 11,  6)],
        ['TGRÃO', 'Plugado',          '#C70039', createCustomHTMLContent("Cliente reservando o espaço disponível para recebimento de farelo 46%"), new Date(2024, 11, 14), new Date(2024, 11, 16)],

        ['T12A',        'Estoque elevado',  '#FDC24E', createCustomHTMLContent("Estoque elevado mas com o navio atracado e em operação"), new Date(2024, 11,  4), new Date(2024, 11,  10)],
        ['HIDROVIAS',   'Plugado',          '#C70039', createCustomHTMLContent("Plugado. Após o recebimento de 18k"), new Date(2024, 11, 14), new Date(2024, 11, 20)],


    ];

    const dataLeftMargin = [

        //Creating Lines
        ['TGG',     '', '#f0f0f0', "",  new Date(2024, 11, 30),  new Date(2024, 11, 30)],
        ['TGG',     '', '#f0f0f0', "",  new Date(2024, 11, 1),   new Date(2024, 11, 1)],
        ['TEG',     '', '#f0f0f0', "",  new Date(2024, 11, 1),   new Date(2024, 11, 1)],
        ['TEAG',    '', '#f0f0f0', "",  new Date(2024, 11, 1),   new Date(2024, 11, 1)],
        ['CUTRALE', '', '#f0f0f0', "",  new Date(2024, 11, 1),   new Date(2024, 11, 1)],
        ['SBR',     '', '#f0f0f0', "",  new Date(2024, 11, 1),   new Date(2024, 11, 1)],
        
        ['TERMAG',      '',                 '#f0f0f0', createCustomHTMLContent("Navio ALKYONI atracado, premissa de 116 vgs na pedra de D+1"),                                              new Date(2024, 11,   1), new Date(2024, 11,  1)],
        ['CUTRALE',     'Plugado',          '#C70039', createCustomHTMLContent("Milho: Em restrição, estoque elevado"),                                                                     new Date(2024, 11,  14), new Date(2024, 11, 16)],
        ['TGG',         'Estoque elevado',  '#FDC24E', createCustomHTMLContent("Milho: Estoque elevado, espaço de 470 vgs base 07h de D"),                                                  new Date(2024, 11,   4), new Date(2024, 11,  6)],
        ['TEG',         'Estoque elevado',  '#FDC24E', createCustomHTMLContent("Milho LDC: Estoque elevado, navio atracado e em operação, base 07h espaço de 28k (Baixo saldo fiscal)"),    new Date(2024, 11,   8), new Date(2024, 11, 18)],
        ['TGG',         'Estoque elevado',  '#FDC24E', createCustomHTMLContent("Milho LDC: Estoque elevado, navio atracado e em operação, base 07h espaço de 28k (Baixo saldo fiscal)"),    new Date(2024, 11,  26), new Date(2024, 11, 30)],

    ];

    // const handleSubmit = (formData) => {
  
    //     handleCloseModal();  // Feche o modal após o envio dos dados
    // };

    return (
       
        <div className="pg-content">
            
            <FarolForm isOpen={isModalOpen} onClose={handleCloseModal}></FarolForm>
            
            <header>
                
                <h1 className="mb-5">Farol dos Terminais</h1>

                <section className="w-full bg-neutro borda-cinza rounded-[7px] p-[1rem] flex justify-between">

                    <input  className="rounded-[4px] text-[0.8rem] h-10" type="text" placeholder="Filtrar"></input>

                    <button className="btn bg-azul-profundo-m hover:bg-azul-profundo-e h-10" onClick={handleOpenModal}>Inserir Novo</button>
                    
                </section>

                <h2 className="my-4" >Margem Direita</h2>

                <section>
                    <GoogleCronogramChart data={dataRightMargin} id="timeline_chart_right" height="520px" />
                </section>

                <h2 className="my-4" >Margem Esquerda</h2>

                <section>
                    <GoogleCronogramChart data={dataLeftMargin} id="timeline_chart_left" height="320px" />
                </section>

            </header>
        
        </div>
    )
}


export default FarolDashboardPage;